<div class="side-line" [ngClass]="color"></div>
<div class="content">
  <ng-content select="[content]"></ng-content>
</div>
